<template lang="pug">
    d2-container()
      //- div(style='font-size:20px;font-weight:700;margin-bottom:20px') {{title}}
      el-form(:inline='true', :model='dataForm' size="mini" label-position='left' label-width="75px" label-suffix=':' )
        el-row(:span='24' type="flex" :gutter="40")
          el-col(:md='8' :sm="12")
            el-radio-group(v-model="timeRange" @change="timeChange" fill="#409EFF" style='display:flex;flex-warp:nowarp')
              el-radio-button(:label="0") 今天
              el-radio-button(:label="7") 最近7天
              el-radio-button(:label="30")  最近30天
              el-radio-button(:label="90")  最近90天
          el-col(:md='8' :sm="12" )
            el-date-picker(v-model="dateTime" @change="dayChange" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期")
          el-col(:md='8' :sm="12" )
            el-radio-group(v-model="dataForm.dateType" @change="dateChange" fill="#409EFF" style='display:flex;flex-warp:nowarp')
              el-radio-button(:label="1") 按日
              el-radio-button(:label="2") 按周
              el-radio-button(:label="3") 按月
        el-row( style='margin:20px 0 0 0' :gutter="40")
          el-col(:span='8')
            el-form-item(label='竞赛类型' size="medium" v-if="tjType ===1")
              el-select.inputWidth(v-model='dataForm.type',placeholder='请选择类型',clearable)
                el-option(v-for="e in competitionType" :label='e.label', :value="e.value")
            el-form-item(label='培训类型' size="medium" v-if="tjType===2")
              el-select.inputWidth(v-model='dataForm.type',placeholder='请选择类型',clearable)
                el-option(v-for="e in trainTypelist" :label='e.label', :value="e.value")
            el-form-item(label='类    型' size="medium" v-if="tjType===3")
              el-select.inputWidth(v-model='dataForm.type',placeholder='请选择类型',clearable @change="childrenT")
                el-option(v-for="e in typeList" :label='e.label', :value="e.value")
          el-col(:span='8')
            el-form-item(label='子分类' size="medium" v-if="tjType===3")
              el-select.inputWidth(v-model='dataForm.childrenType',placeholder='请选择类型',clearable)
                el-option(v-for="e in childrenTypeList" :label='e.label', :value="e.value")
          el-col(:span='8')
            el-form-item(label='主办方' size="medium")
              el-select.inputWidth(v-model='dataForm.orgId',placeholder='请选择类型',filterable,clearable)
                el-option(v-for="(e,i) in orgList" :key="i" :label='e.name', :value="e.orgId" )
        el-row(:span='24' :gutter="40")
          el-col(:span='8')
            el-button(type='primary' v-show="tjType===1 && isAuth('tj:statical:cs')" @click="exportExcel(1)" style="margin-left:0") 导出报表
            el-button(type='primary' v-show="tjType===2 && isAuth('tj:statical:ts')" @click="exportExcel(2)" style="margin-left:0") 导出报表
            el-button(type='primary' v-show="tjType===3 && isAuth('tj:statical:fs')" @click="exportExcel(3)" style="margin-left:0") 导出报表
          el-col(:span='12' type='flex' justify="start" v-if="tjType===1")
            el-radio-group(v-model="dataForm.numType" @change="numTypeChange" fill="#409EFF")
              el-radio-button(:label="1") 开赛数
              el-radio-button(:label="2") 签位数
          el-col(:span='12' type='flex' justify="start" v-if="tjType===2")
            el-radio-group(v-model="dataForm.numType" @change="numTypeChange" fill="#409EFF")
              el-radio-button(:label="1") 开班数
              el-radio-button(:label="2") 签位数
          el-col(:span='12' type='flex' justify="start" v-if="tjType===3")
            el-radio-group(v-model="dataForm.numType" @change="numTypeChange" fill="#409EFF")
              el-radio-button(:label="1") 订单数
              el-radio-button(:label="2") 流水金额
              el-radio-button(:label="3") 入账金额
              el-radio-button(:label="4") 退费金额
              el-radio-button(:label="5") 按场次
          el-col(:span='2')
            el-button(type='primary' icon="el-icon-search" @click="onSearch" style="float:right") 查询
        el-row(:span='23' type='flex' justify="end")
          h3(style="margin:20px 100px 0 0;color:red") 总计： {{total}}
        el-row(:span='24' style='height:500px')
          common-chart(:tjType="tjType" :datalist="chartData")
</template>

<script>
import CommonChart from './CommonChart.vue'
import table from './table.js'
export default {
  props: ['tjType'], //tjType:1, //竞赛统计 2培训统计 3财务统计
  components: {
    CommonChart
  },
  data () {
    return {
      tjTypelist: { 1: '竞赛统计', 2: '培训统计', 3: '财务统计' },
      title: '',
      timeRange: 7,
      dateTime: '',
      total: null,
      dataForm: {
        staticalType: this.tjType,
        payStrTime: '',
        payEndTime: '',
        type: '', //竞赛/培训类型
        childrenType: '',
        orgId: '',
        numType: 1,
        dateType: 1,
        downLoad: false
      },
      competitionType: [
        { label: '全部', value: '' },
        { label: '分级公开赛', value: 1 },
        { label: '俱乐部公开赛', value: 2 }
      ],
      trainTypelist: [
        { label: '全部', value: '' },
        { label: '分级单次培训', value: 3 },
        { label: '分级整期培训', value: 4 },
        { label: '青少年儿童培训', value: 5 },
        { label: '个人定制化培训', value: 6 },
        { label: '团体定制化培训', value: 7 }
      ],
      typeList: [
        { label: '全部', value: '' },
        { label: '竞赛', value: 1 },
        { label: '培训', value: 2 }
      ],

      childrenTypeList: [
        { label: '全部', value: '' },
        { label: '分级公开赛', value: 1 },
        { label: '青少年比赛', value: -1 },
        { label: '俱乐部公开赛', value: 2 },
        { label: '分级单次培训', value: 3 },
        { label: '分级整期培训', value: 4 },
        { label: '青少年儿童培训', value: 5 },
        { label: '个人定制化培训', value: 6 },
        { label: '团体定制化培训', value: 7 }
      ],
      orgList: [],
      chartData: []
    }
  },
  created () {
    this.initCity()
    // this.title = this.tjTypelist[this.tjType]
    this.timeChange(7) //默认7天
    console.log(this.tjType, '类型')
    this.getCharDate()
  },
  mounted () {
      this.onSearch()
  },
  methods: {
    childrenT (val) {
      console.log(val)
      this.dataForm.childrenType = ''
      if (val === 1) {
        this.childrenTypeList = [
          { label: '全部', value: '' },
          { label: '分级公开赛', value: 1 },
          { label: '青少年比赛', value: -1 },
          { label: '俱乐部公开赛', value: 2 }
        ]
      } else if (val === 2) {
        this.childrenTypeList = [
          { label: '全部', value: '' },
          { label: '分级单次培训', value: 3 },
          { label: '分级整期培训', value: 4 },
          { label: '青少年儿童培训', value: 5 },
          { label: '个人定制化培训', value: 6 },
          { label: '团体定制化培训', value: 7 }
        ]
      } else {
        this.childrenTypeList = [
          { label: '全部', value: '' },
          { label: '分级公开赛', value: 1 },
          { label: '青少年比赛', value: -1 },
          { label: '俱乐部公开赛', value: 2 },
          { label: '分级单次培训', value: 3 },
          { label: '分级整期培训', value: 4 },
          { label: '青少年儿童培训', value: 5 },
          { label: '个人定制化培训', value: 6 },
          { label: '团体定制化培训', value: 7 }
        ]
      }
    },
    onSearch () {
      this.getCharDate()
    },
    getCharDate () {
      this.dataForm.payStrTime = this.dateTime[0]
      this.dataForm.payEndTime = this.dateTime[1]
      this.dataForm.downLoad = false
       if (this.dataForm.staticalType == '3' && this.dataForm.numType == '5') {
        this.$message.error('按场次只适用于导出列表!')
        return
      }
      this.$http({
        url: this.$http.adornUrl(`/statical/list`),
        method: 'post',
        data: this.dataForm
      }).then(res => {
        this.chartData = res.rows
        this.total = res.total
      })
    },
    timeChange (val) {
      const end = new Date()
      const start = new Date()
      if (val !== 0) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * (val - 1));
      } else {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * val);
      }
      this.dateTime = [this.getime(start), this.getime(end)]
      // start.setTime(start.getTime() - 3600 * 1000 * 24 * (val - 1))
      // this.dateTime = [this.getime(start), this.getime(end)]
    },
    getime (time) {
      let str = ''
      let y = time.getFullYear()
      let m = (time.getMonth() + 1 + '').padStart(2, '0')
      let d = (time.getDate() + '').padStart(2, '0')
      str = `${y}-${m}-${d}`
      return str
    },
     getDownLoadTime (time) {
      let str = ''
      let y = time.getFullYear()
      let m = (time.getMonth() + 1 + '').padStart(2, '0')
      let d = (time.getDate() + '').padStart(2, '0')
      str = `${y}${m}${d}`
      return str
    },
    dayChange () {
      this.timeRange = ''
    },
    dateChange (val) {
      this.dataForm.dateType = val
    },
    numTypeChange (val) {
      this.dataForm.numType = val
    },
    //主办方
    initCity () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get'
      }).then(data => {
        this.orgList = data && data.code === 0 ? data.list : []
      })
    },
    // 导出
    exportExcel (val) {
      let columns = table.compColumns1
      let title = '竞赛-开赛数统计表'
      if (val === 1 && this.dataForm.numType === 2) {
        title = '竞赛-签位数统计表'
        columns = table.compColumns2
      } else if (val === 2 && this.dataForm.numType === 1) {
        title = '培训-开班数统计表'
        columns = table.compColumns1
      } else if (val === 2 && this.dataForm.numType === 2) {
        title = '培训-签位数统计表'
        columns = table.trainColumns2
      } else if (val === 3 && this.dataForm.numType === 1) {
        title = '财务-订单数统计表'
        columns = table.compColumns1
      } else if (val === 3 && this.dataForm.numType === 2) {
        title = '财务-流水金额统计表'
        columns = table.financeColum2
      } else if (val === 3 && this.dataForm.numType === 3) {
        title = '财务-入账金额统计表'
        columns = table.financeColum2
      } else if (val === 3 && this.dataForm.numType === 4) {
        title = '财务-退款金额统计表'
        columns = table.financeColum2
      } else if (val === 3 && this.dataForm.numType === 5) {
        title = '财务-按场次统计表'
        columns = table.financeColum3
      }
       //财务按具体类型导出
      if (this.dataForm.staticalType == '3' && this.dataForm.numType == '5' && this.dataForm.type == '') {
        this.$message.error('按场次导出列表必须选择具体类型!')
          return
      }
      this.dataForm.payStrTime = this.dateTime[0]
      this.dataForm.payEndTime = this.dateTime[1]
      this.dataForm.downLoad = true
      let exportData
      this.$http({
         url: this.$http.adornUrl('/statical/list'),
         method: 'post',
         data: this.dataForm
       }).then(data => {
        console.log('统计信息：', data)
         if (data && data.rows.length <= 0) {
             this.$message.info('没有要导出的数据!')
             return
          } else {
             exportData = data.rows
          }
           console.log('导出的订单数据：', exportData)
           let downTime = this.getDownLoadTime(new Date())
           this.$export
             .excel({
               columns: columns,
               data: exportData,
               title: title + downTime
            })
             .then(() => {
              this.$message.success('导出表格成功')
             })
       })
    }
  }

}
</script>
<style scoped>

</style>
